define.alias("shared/components/shared/mavely/links/folders-tab", "calendar/components/shared/mavely/links/folders-tab");